import { render, staticRenderFns } from "./allocationStorehouseEnterList.vue?vue&type=template&id=708535e4&scoped=true"
import script from "./allocationStorehouseEnterList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseEnterList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseEnterList.vue?vue&type=style&index=0&id=708535e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708535e4",
  null
  
)

export default component.exports